import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

export const BundleType = {
  LIGHT: 'light',
  FULL: 'full'
} as const;

export const TimelineChronologyType = {
  TIMELINE: 'timeline',
  CHRONOLOGY: 'chronology'
} as const;

export type BundleTypeKeys = (typeof BundleType)[keyof typeof BundleType];
export type TimelineChronologyTypeKeys = (typeof TimelineChronologyType)[keyof typeof TimelineChronologyType];

interface SharedDataState {
  bundleId: string | null;
  initialPageId: string | null;
  activeBundleType: BundleTypeKeys | null;
  activeTimelineChronologyType: TimelineChronologyTypeKeys | null;
}

const initialState: SharedDataState = {
  bundleId: null,
  initialPageId: null,
  activeBundleType: null,
  activeTimelineChronologyType: null
};

const sharedDataSlice = createSlice({
  name: 'sharedData',
  initialState,
  reducers: {
    setSharedDataBundleId: (state, action: PayloadAction<string | null>) => {
      state.bundleId = action.payload;
    },
    setSharedDataInitialPageId: (state, action: PayloadAction<string | null>) => {
      state.initialPageId = action.payload;
    },
    setSharedDataActiveBundleType: (state, action: PayloadAction<BundleTypeKeys | null>) => {
      state.activeBundleType = action.payload;
    },
    setSharedDataActiveTimelineChronologyType: (state, action: PayloadAction<TimelineChronologyTypeKeys | null>) => {
      state.activeTimelineChronologyType = action.payload;
    }
  }
});

export const {
  setSharedDataBundleId,
  setSharedDataInitialPageId,
  setSharedDataActiveBundleType,
  setSharedDataActiveTimelineChronologyType
} = sharedDataSlice.actions;

export const selectSharedDataBundleId = (state: RootState) => state.sharedData.bundleId;
export const selectSharedDataInitialPageId = (state: RootState) => state.sharedData.initialPageId;
export const selectSharedDataActiveBundleType = (state: RootState) => state.sharedData.activeBundleType;
export const selectSharedDataActiveTimelineChronologyType = (state: RootState) =>
  state.sharedData.activeTimelineChronologyType;

export const sharedDataReducer = sharedDataSlice.reducer;
